import {useSelector} from 'react-redux'
import {HeaderUserMenu} from '../../../partials'

// Signed-in user block at the top of the sidebar; click opens the account menu.
const AsideFooter = () => {
  const {details} = useSelector((state) => state.users)
  const name = [details?.first_name, details?.last_name].filter(Boolean).join(' ')

  return (
    <div className='hl-user' id='kt_header_user_menu_toggle'>
      <div
        className='hl-user-trigger'
        data-kt-menu-trigger='click'
        data-kt-menu-overflow='false'
        data-kt-menu-placement='bottom-start'
        title='User profile'
      >
        <div className='hl-user-avatar'>
          {details?.profile_pic ? (
            <img src={details.profile_pic} alt='' />
          ) : (
            <span className='material-symbols-rounded'>person</span>
          )}
        </div>
        <div className='hl-user-text'>
          <div className='hl-user-name'>{name || 'My Account'}</div>
          {details?.email && <div className='hl-user-email'>{details.email}</div>}
        </div>
      </div>

      <HeaderUserMenu />
    </div>
  )
}

export {AsideFooter}
